<template>
	<VerticalLayout>
		<span v-if="showLabel">{{ $t(labelKey) }}</span>
		<Select
			class="width-100"
			v-model:value="selectedId"
			:options="options"
			:allowClear="allowClear"
			@change="onChange"
		/>
	</VerticalLayout>
</template>

<script>
import { ref, computed, toRef, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { Select } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout';

import { useSubnetworkOptions } from '@/components/common/useSubnetworkOptions';

export default {
	components: { VerticalLayout, Select },
	props: {
		onChange: {
			type: Function,
			required: false,
			default: () => {},
		},
		labelKey: {
			type: String,
			default: 'controls.subNetworkFilter.label',
		},
		showLabel: {
			type: Boolean,
			default: true,
		},
		allSubnetsOption: {
			type: Boolean,
			default: false,
		},
		allowClear: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { expose }) {
		const { t } = useI18n();
		const { subNetworkOptions } = useSubnetworkOptions();
		const allSubnetsOptionRef = toRef(props, 'allSubnetsOption');
		const allowClearRef = toRef(props, 'allowClear');
		const options = computed(() => {
			let result = [];
			if (allSubnetsOptionRef.value) {
				result.push({
					value: 0,
					label: t('home-map.subNetworkFilter.allSubnets'),
				});
			}
			result.push(...subNetworkOptions.value);
			return result;
		});
		const getDefaultSelectedId = () => {
			if (allowClearRef.value) {
				return null;
			}
			if (options.value.length > 0) {
				return options.value[0].value;
			}
			return null;
		}
		const selectedId = ref(getDefaultSelectedId());
		watch(options, (newValue, oldValue) => {
			if (newValue.length > 0 && oldValue.length === 0) {
				selectedId.value = getDefaultSelectedId();
			}
		});
		expose({
			selectedId,
			options,
		});
		return {
			selectedId,
			options,
		}
	},
}
</script>
